//# sourceMappingURL=my-date-model.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-date-model.interface.js
// module id = 1003
// module chunks = 0